import { InvoiceInterface } from 'pages/users/subscription/invoices/invoices.interface';
import { getSilentFetch } from 'request/request';

export const getInvoices = async (): Promise<InvoiceInterface[]> => {
  return await getSilentFetch('/credits/invoices');
};
